































































import { AuthApiClient } from "@/api/auth_client";
import { AuthResponse } from "@/interfaces/auth";
import { Component, Vue } from "vue-property-decorator";
import CardComponent from "@/components/CardComponent.vue";

@Component({
  components: {
    CardComponent
  }
})
export default class SignUp extends Vue {
  private api = new AuthApiClient();

  private isLoading = false;
  private message = "";

  private form: any = {
    username: "",
    password: ""
  };

  submit() {
    this.isLoading = true;

    this.api
      .signup(this.form.username, this.form.password)
      .then((response: AuthResponse) => {
        if (response.ok) {
          this.message = "";
          this.$store.commit("basic", {
            key: "userEmail",
            value: this.form.username
          });

          this.$router.push("/activate");
        }
      })
      .catch(error => {
        if (error && typeof error === "string") {
          this.message = this.$t(error);
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
